import { withField } from '@libs/reduxForm';

import InputBase from './InputBase';

const Input = withField()((props) => <InputBase {...props} />);

export default Input;
